/**
 * Sort select component.
 *
 * Dropdown for changing product sort order.
 */

'use client';

import type { SortOption } from '@/lib/algolia';
import { useSearchParams } from '@/lib/algolia/hooks/useSearchParams';
import { useTranslations } from 'next-intl';
import styles from './SortSelect.module.scss';

interface SortSelectProps {
  readonly currentSort: SortOption;
}

const SORT_OPTIONS: { value: SortOption; labelKey: string }[] = [
  { value: 'relevance', labelKey: 'relevance' },
  { value: 'price_asc', labelKey: 'priceLowHigh' },
  { value: 'price_desc', labelKey: 'priceHighLow' },
  { value: 'newest', labelKey: 'newest' },
];

export function SortSelect({ currentSort }: Readonly<SortSelectProps>) {
  const { setSort } = useSearchParams();
  const t = useTranslations('plp.sort');

  return (
    <div className={styles.sortSelect}>
      <label htmlFor="sort-select" className={styles.label}>
        {t('sortBy')}:
      </label>
      <select
        id="sort-select"
        value={currentSort}
        onChange={(e) => setSort(e.target.value as SortOption)}
        className={styles.select}
      >
        {SORT_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {t(option.labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
}
